import React from 'react';
import cx from './cx';

const AppAlert = ({ variant = 'danger', className = '', children, ...rest }) => (
  <div className={cx('alert', `alert-${variant}`, className)} role="alert" {...rest}>
    {children}
  </div>
);

export default AppAlert;
